<div style="background:#ddd; position:absolute; left: 0; top: 0; width: 100%; height: 100%;" class="d-flex align-items-center justify-content-center">
  <div class="bg-white">
    <router-outlet></router-outlet>
  </div>
</div>
